const CardDivider = () => (
  <div className={'px-16'}>
    <hr className="h-px opacity-15 border-background-title-color m-3" />
  </div>
);

export default CardDivider;
